//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepState } from './Enums';

export class RepertoireUpdateItem extends ItemBase {
    Composer?: string | null;
    Description?: string | null;
    Difficulty?: string | null;
    Duration?: number | null;
    Genre?: string | null;
    Instrument?: string | null;
    Language?: string | null;
    Notes?: string | null;
    Source?: string | null;
    Title?: string | null;
    Status?: RepState;
    TeacherID?: string | null;

    constructor(initializer?: Partial<RepertoireUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireUpdateItem";
}
